import React from 'react';
import { Container } from '@acast/decibel';

export default function ContentContainer({ children }) {
  return (
    <Container as="main" py={6}>
      {children}
    </Container>
  );
}
